import { GroupNotesFolderType } from '../../types/backroomSection';

export const GROUP_NOTES_STREAM_GROUP_ID = 'GROUP_NOTES_STREAM_GROUP_ID';
export const NOTES_PER_FETCH = 10;
export const FEED_COMMENTS_ITEMS_PER_FETCH = 20;

export const getGroupNotesStreamId = (folder: GroupNotesFolderType): string =>
  [GROUP_NOTES_STREAM_GROUP_ID, folder, 'ids_stream']
    .filter(value => value)
    .join('_')
    .toUpperCase();
